module.exports = __webpack_public_path__ + "61344d74e98f932da514423a6010f683.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/graviton_-_agudabold-webfont.woff2
// module id = 56
// module chunks = 28